import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT, BRAND_NAME } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import DownloadBlock from './DownloadBlock';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './ToolbarPage.scss';

export class ToolbarPage extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-toolbar">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.TOOLBAR_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{convertHtmlToReactDomWithParams(i18n.PAGE_TITLE, BRAND_NAME)}</h1>
                <div className="bloc-toolbar">
                    <div className="explaination">
                        <p>
                            <b>{convertHtmlToReactDomWithParams(i18n.TEXT1, BRAND_NAME)}</b>
                        </p>
                        <p>{i18n.TEXT2}</p>
                        <DownloadBlock />
                    </div>
                    <img
                        src={`${STATIC_ROOT}/toolbars/toolbar_visuel.png`}
                        className="visuel"
                        width="424"
                        height="236"
                        alt="toolbar"
                    />
                </div>
                <h3 className="sectionTitle">
                    {convertHtmlToReactDomWithParams(i18n.SECTION_TITLE, BRAND_NAME)}
                </h3>
                <div className="explanationContainer">
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT3)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc1.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT4)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc2.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT5, BRAND_NAME)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc3.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                </div>
                <div className="DownloadBloc">
                    <h3>{convertHtmlToReactDomWithParams(i18n.TEXT6, BRAND_NAME)}</h3>
                    <p>{i18n.TEXT7}</p>
                    <DownloadBlock />
                </div>
                <div className="footer">
                    <p>{i18n.FOOTER_TEXT}</p>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TOOLBAR
    };
};

export default withTemplate(connect(mapStateToProps)(ToolbarPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/ToolbarPage.js